export default "__VITE_ASSET__3xZqU_Ap__"